import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import { viewQualityOfEarningsPath } from 'common/services/urlService';
import { AnalysisTypes } from 'features/analyses/analysesService';
import EditStructuredAnalysis from 'features/analyses/EditAnalysis/EditStructuredAnalysis';
import { ConnectedContentContextProvider } from 'features/narratives/Context/ConnectedContentContext';
import { RedirectV1V2 } from '../../RedirectV1V2';

const QofEEditForm = () => {
  return (
    <ConnectedContentContextProvider>
      <RedirectV1V2>
        <EditStructuredAnalysis
          getReturnPath={viewQualityOfEarningsPath}
          type={AnalysisTypes[Constants.QUALITY_OF_EARNINGS]}
          documentCode={Constants.QUALITY_OF_EARNINGS}
          showLinkedAdjustments
        />
      </RedirectV1V2>
    </ConnectedContentContextProvider>
  );
};

export default QofEEditForm;
